// 📄 pages/Proyectos/components/AusenciasProximaSemanaBanner.tsx
// Alerta "al entrar al proyecto" (vive en la landing, ver
// ProjectSolutionsHome.tsx) — si algún miembro del equipo tiene una
// ausencia cargada (usuarios/{uid}/vacaciones) que se cruza con los
// próximos 7 días, se avisa acá. Mismo estilo que ChecklistIncidentBanner.tsx.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { Project } from '../../../services/projectService.ts';
import { VacacionDeUsuario, getVacacionesDeUsuarios, seSuperponeConProximosDias } from '../../../services/vacacionesService.ts';

interface AusenciasProximaSemanaBannerProps {
  project: Project;
  projectId: string;
}

export default function AusenciasProximaSemanaBanner({ project, projectId }: AusenciasProximaSemanaBannerProps) {
  const [proximas, setProximas] = useState<VacacionDeUsuario[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const uids = project.miembrosUids || [];
    if (uids.length === 0) { setLoading(false); return; }
    getVacacionesDeUsuarios(uids)
      .then((lista) => setProximas(lista.filter((v) => seSuperponeConProximosDias(v))))
      .catch((err) => console.error('Error cargando ausencias del equipo:', err))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.miembrosUids]);

  if (loading || proximas.length === 0) return null;

  const nombrePorUid = new Map(project.miembros.map((m) => [m.userId, m.email]));

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 text-amber-300 rounded-xl p-4 text-sm flex items-center justify-between gap-3 animate-fadeIn mb-2">
      <div className="flex items-center gap-2.5 min-w-0">
        <CalendarDays className="w-5 h-5 flex-shrink-0" />
        <span className="truncate">
          {proximas.length === 1
            ? `${nombrePorUid.get(proximas[0].userId) || 'Alguien'} va a estar fuera del equipo la próxima semana (${proximas[0].fechaInicio} → ${proximas[0].fechaFin}).`
            : `${proximas.length} miembros del equipo van a estar fuera la próxima semana.`}
        </span>
      </div>
      <Link to={`/proyecto/${projectId}/ausencias`} className="underline whitespace-nowrap font-medium hover:text-amber-200 flex-shrink-0">
        Ver ausencias
      </Link>
    </div>
  );
}
